import React from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BreadCrumb from '../../components/BreadCrumb';
import { Link } from 'react-router-dom';

const DigitalMarketing = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb 
                        active_page="Digital Marketing"
                        prev_sub_page={{
                            'link':'/services',
                            'text':'Services'
                        }}
                    />
                    <div class="inner-container">
                        <h2>Digital Marketing</h2>
                        <h3>Let’s Strategise Together</h3>
                        <p>We work with you, not for you. Be it content, designing or strategies, we take care of all of it.</p>
                        <h3>Experience Led & Outcome Focused</h3>
                        <p>Best recipes are made using the right proportion of ingredients, same goes with digital marketing. For a comprehensive outreach we ensure all the campaigns are aligned across various platforms.</p>
                        <h3>Agile SEO Methodology</h3>
                        <p>Involves building customized SEO strategies well in line with your business needs, demands, and targeted users.</p>
                        <img alt="" src={require('../../assets/images/services/digital-marketing.png')} width="100%"/>
                        <h3>Discover</h3>
                        <p>Understand business needs and demands after an initial review. This is followed by identifying the key performance indicators, conversion path, and keyword research.</p>
                        <p>This gives us insights on company processes, purpose, and goals.</p>
                        <h3>Analyze</h3>
                        <p>Involves site audit, review of site analytics, and traffic patterns. On site technical issues if any are also identified at this stage. Competitor analysis forms a large part of our strategy and we utilise their analytics to further refine our approaches for SEO.</p>
                        <h3>Strategize</h3>
                        <p>This includes planning of the expected outcomes for all kinds of marketing channels along with estimated time. This ensures our efforts are in line with immediate targeted results.</p>
                        <h3>Execute</h3>
                        <p>In this phase we optimize web pages with high performing keywords using various approaches, improve site structure, manage business listings to drive traffic & enhance ROI.</p>
                        <h3>Measure</h3>
                        <p>Involves monitoring and analyzes of keyword ranking, bounce rates, conversion percentages, local visibility, click through rates to further optimize strategies.</p>
                        <h3>Report</h3>
                        <p>This includes KPI trends, traffic analysis, and ranking. Gives us deeper insights about campaigns that worked out the best and provides an overall view on the site performance.</p>
                        <h3>Adjust</h3>
                        <p>Search engines evolve continuously over time and this requires optimizing strategies based on algorithm updates and market trends.</p>
                        <p>We make the necessary adjustments and would keep you informed on the progress at all times.</p>
                        <h2 className="mt-5">What We Do</h2>


                        <h3>
                            <Link to="/services/digital-marketing/search-engine-optimization">Search Engine Optimization</Link>
                        </h3>
                        <p>Involves auditing your site, keyword research, on page optimization, off page optimization, local seo, technical seo and activity reports.</p>
                        <h3>
                            <Link to="/services/digital-marketing/social-media-marketing">Social Media Marketing</Link>
                        </h3>
                        <p>Leverage the power of social media networks to achieve branding goals. Stay connected with your audience and build a community around your brand</p>
                        <h3>
                            <Link to="/services/digital-marketing/search-engine-marketing">Search Engine Marketing</Link>
                        </h3>
                        <p>Improve your digital presence and secure your brand recognition. We ensure search engines find your site and make it rank high in search engine page results.</p>
                        <h3>
                            <Link to="/services/digital-marketing/ppc-marketing">PPC Marketing</Link>
                        </h3>
                        <p>Give your brand a wider reach & exposure. While SEO offers long term results, you might sometimes need an immediate boost to drive in traffic and increase sales.</p>
                        <h3>
                            <Link to="/services/digital-marketing/youtube-marketing">YouTube Marketing</Link>
                        </h3>
                        <p>Get your message across through videos by engaging audience by telling a story. Add a tinge of entertainment to your marketing through product demonstrations, testimonials, interviews, case studies, & so on.</p>
                        <h3>
                            <Link to="/services/digital-marketing/email-marketing">Email Marketing</Link>
                        </h3>
                        <p>Cement your brand identity. We help you plan, build, execute all kinds of email marketing campaigns i.e., newsletters, product, promotional, and transactional.</p>
                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default DigitalMarketing;